import { Context } from "@opentelemetry/api";
import type { Span } from "@opentelemetry/sdk-trace-base";
import { RouteConfig } from "./types";
import { calculateRouteName, getRouteParams } from "./utils";

class ReactRouterSpanProcessor {
  private routeConfig: RouteConfig;

  constructor(routeConfig: RouteConfig) {
    this.routeConfig = routeConfig;
  }

  onStart(span: Span, _parentContext: Context): void {
    // Type assertion needed due to type mismatch between SpanProcessor interface
    // and actual Span implementation from Honeycomb SDK
    const spanWithAttributes = span as Span & {
      setAttribute: (key: string, value: unknown) => void;
    };

    // Apply global attributes to every span so auto-instrumented spans carry
    // the same context as analytics events.
    const globalAttributes = window.AttributeStore?.getGlobalAttributes();
    if (globalAttributes) {
      Object.entries(globalAttributes).forEach(([key, value]) => {
        spanWithAttributes.setAttribute(key, value);
      });
    }

    const matchedRoute = calculateRouteName(
      window.location.pathname,
      this.routeConfig,
    );
    if (matchedRoute) {
      spanWithAttributes.setAttribute("page.route_name", matchedRoute.name);
      spanWithAttributes.setAttribute("page.route", matchedRoute.route);
      const params = getRouteParams(
        matchedRoute.route,
        window.location.pathname,
      );
      Object.entries(params).forEach(([key, value]) => {
        spanWithAttributes.setAttribute(`page.route_param.${key}`, value);
      });
    }
  }

  onEnd(): void {}

  forceFlush() {
    return Promise.resolve();
  }

  shutdown() {
    return Promise.resolve();
  }
}

export default ReactRouterSpanProcessor;
